import {RecordForm} from '../forms/RecordForm';


import {useProductFeature} from '../hooks/useProductFeature.ts';
import {IndexPageNavigation} from "../navigation/IndexPageNavigation";
import {FormPageLayout} from "@flexinet/ui-components";
import {moduleConfig} from "../config";


export const AddPage = () => {

    const {
        record,
        createRecord,
    } = useProductFeature();

    return (
        <FormPageLayout
            title={`Add ${moduleConfig.titles.singular}`}
            pageNavigation={<IndexPageNavigation/>}
        >
            <RecordForm record={record || {} as any} handleSubmit={createRecord}/>
        </FormPageLayout>
    );
};
